import { memo, useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";
import { useAppContext } from "../../Context/AppContext";
import { acknowledgeEarlyStageRejectionNoticeLocal } from "../../utils/earlyStageRejectionNotice";
import EarlyStageRejectionContactModal from "./EarlyStageRejectionContactModal";

interface EarlyStageRejectedNoticeProps {
  rejectedAt?: string | null;
  onContinue: () => void;
}

function EarlyStageRejectedNoticeInner({
  rejectedAt,
  onContinue,
}: EarlyStageRejectedNoticeProps) {
  const { user, objectId: contextObjectId } = useAppContext();
  const [loading, setLoading] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  const objectId =
    contextObjectId?.trim() || user?.user?.objectId?.trim() || "";
  const email = user?.user?.email?.trim() ?? "";
  const name = [user?.user?.firstName, user?.user?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  const handleContinue = () => {
    setLoading(true);
    try {
      if (objectId && rejectedAt?.trim()) {
        acknowledgeEarlyStageRejectionNoticeLocal(objectId, rejectedAt);
      }
      onContinue();
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex flex-column gap-4 p-4 rounded-4 bg-white min-vh-50">
        <Alert variant="danger" className="mb-0">
          <p className="mb-2">
            Your request was rejected. If you have any queries, please email{" "}
            <a href="mailto:enquiries@smbf.global">enquiries@smbf.global</a>
            .
          </p>
          <p className="mb-0 small text-muted">
            Your membership continues at <strong>£10/month</strong>. You can
            complete registration without choosing a different plan.
          </p>
        </Alert>

        <div className="d-flex flex-wrap gap-2">
          <Button
            variant="primary"
            disabled={loading}
            onClick={handleContinue}
          >
            {loading ? (
              <>
                <Spinner
                  animation="border"
                  size="sm"
                  className="me-2"
                  aria-hidden
                />
                Continuing…
              </>
            ) : (
              "Continue registration"
            )}
          </Button>
          <Button
            variant="outline-primary"
            onClick={() => setShowContactModal(true)}
          >
            Contact Us
          </Button>
        </div>
      </div>

      <EarlyStageRejectionContactModal
        show={showContactModal}
        onHide={() => setShowContactModal(false)}
        memberEmail={email}
        memberName={name}
      />
    </>
  );
}

export default memo(EarlyStageRejectedNoticeInner);
